/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PartialUpdateReminderMutationRequest,
  PartialUpdateReminderMutationResponse,
  PartialUpdateReminderPathParams,
  PartialUpdateReminder400,
  PartialUpdateReminder404,
  PartialUpdateReminder500,
} from '../types/PartialUpdateReminder'

function getPartialUpdateReminderUrl({
  id,
}: {
  id: PartialUpdateReminderPathParams['id']
}) {
  const res = {
    method: 'PATCH',
    url: `/api/v1/reminders/reminders/${id}/` as const,
  }
  return res
}

/**
 * @description Update an existing reminder (partial update).
 * Delegates to UpdateReminderUsecase for business logic.
 * @summary Partial update of an existing reminder
 * {@link /api/v1/reminders/reminders/:id/}
 */
export async function partialUpdateReminder(
  { id }: { id: PartialUpdateReminderPathParams['id'] },
  data?: PartialUpdateReminderMutationRequest,
  config: Partial<RequestConfig<PartialUpdateReminderMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    PartialUpdateReminderMutationResponse,
    ResponseErrorConfig<
      | PartialUpdateReminder400
      | PartialUpdateReminder404
      | PartialUpdateReminder500
    >,
    PartialUpdateReminderMutationRequest
  >({
    method: 'PATCH',
    url: getPartialUpdateReminderUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
